/**
 * Hr api spec
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface EditStatusDto { 
    /**
     * The code of the status
     */
    code: string;
    /**
     * The kind of status
     */
    kind: EditStatusDto.KindEnum;
    /**
     * Optional note for the status
     */
    note?: string;
}
export namespace EditStatusDto {
    export const KindEnum = {
        Progress: 'progress',
        Blocked: 'blocked'
    } as const;
    export type KindEnum = typeof KindEnum[keyof typeof KindEnum];
}


